import {performRequest, TRequestPromise} from 'shared/utils';

import {convertParamsForRequest} from '../utils/data.utils';

export interface IDashboardDataResponse {
    dataTable: { entityName: string; entityDescription: string; count: number }[];
    recordsTotal: number;
}

export const fetchDashboardData = (
    referenceUrl: string, referenceParams?: Record<string, any>,
): TRequestPromise<IDashboardDataResponse> => performRequest({
    url: `${referenceUrl}`,
    method: 'GET',
    params: referenceParams && convertParamsForRequest(referenceParams),
});
